import { HelmetDexteel } from "@dexteel/mesf-core";
import { BilletsBetweenCobblesReport } from "./components/BilletsBetweenCobblesReport";

export const BilletsBetweenCobblesPage = () => {
	return (
		<>
			<HelmetDexteel title="Billets Between Cobbles" />
			<BilletsBetweenCobblesReport />
		</>
	);
};
